import "@/App.css";
import { Toaster } from "sonner";
import useLenis from "@/hooks/useLenis";
import Cursor from "@/components/Cursor";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Mates from "@/components/Mates";
import Metrics from "@/components/Metrics";
import MarqueeBand from "@/components/MarqueeBand";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import Clients from "@/components/Clients";
import Contact from "@/components/Contact";

function App() {
  useLenis();

  return (
    <div className="App grain">
      <Cursor />
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141418",
            border: "1px solid rgba(255,255,255,0.1)",
            color: "#fff",
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <Services />
        <Mates />
        <Metrics />
        <MarqueeBand />
        <Portfolio />
        <About />
        <Clients />
        <Contact />
      </main>
    </div>
  );
}

export default App;
